import { createActions } from 'redux-actions'

export const INIT_POINT_BALANCE_INFO = "INIT_POINT_BALANCE_INFO";

export const REQUEST_BIG_CARD_NUMBER_START = "REQUEST_BIG_CARD_NUMBER_START";
export const REQUEST_BIG_CARD_NUMBER_SUCCESS = "REQUEST_BIG_CARD_NUMBER_SUCCESS";
export const REQUEST_BIG_CARD_NUMBER_FAIL = "REQUEST_BIG_CARD_NUMBER_FAIL";

export const REQUEST_BIG_CARD_INFO_START = "REQUEST_BIG_CARD_INFO_START";
export const REQUEST_BIG_CARD_INFO_SUCCESS = "REQUEST_BIG_CARD_INFO_SUCCESS";
export const REQUEST_BIG_CARD_INFO_FAIL = "REQUEST_BIG_CARD_INFO_FAIL";

export const REQUEST_POINT_BALANCE_START = "REQUEST_POINT_BALANCE_START";
export const REQUEST_POINT_BALANCE_SUCCESS = "REQUEST_POINT_BALANCE_SUCCESS";
export const REQUEST_POINT_BALANCE_FAIL = "REQUEST_POINT_BALANCE_FAIL";

export const REQUEST_POINT_EXPIRE_START = "REQUEST_POINT_EXPIRE_START";
export const REQUEST_POINT_EXPIRE_SUCCESS = "REQUEST_POINT_EXPIRE_SUCCESS";
export const REQUEST_POINT_EXPIRE_FAIL = "REQUEST_POINT_EXPIRE_FAIL";

export const {

    initPointBalanceInfo,

    requestBigCardNumberStart,
    requestBigCardNumberSuccess,
    requestBigCardNumberFail,

    requestBigCardInfoStart,
    requestBigCardInfoSuccess,
    requestBigCardInfoFail,

    requestPointBalanceStart,
    requestPointBalanceSuccess,
    requestPointBalanceFail,

    requestPointExpireStart,
    requestPointExpireSuccess,
    requestPointExpireFail,

} = createActions({

    [INIT_POINT_BALANCE_INFO]: (req) => ({ req }),

    [REQUEST_BIG_CARD_NUMBER_START]: (req) => ({ ...req }),
    [REQUEST_BIG_CARD_NUMBER_SUCCESS]: (res) => ({ res }),
    [REQUEST_BIG_CARD_NUMBER_FAIL]: (res) => ({ res }),

    [REQUEST_BIG_CARD_INFO_START]: (req) => ({ ...req }),
    [REQUEST_BIG_CARD_INFO_SUCCESS]: (res) => ({ res }),
    [REQUEST_BIG_CARD_INFO_FAIL]: (res) => ({ res }),

    [REQUEST_POINT_BALANCE_START]: (req) => ({ ...req }),
    [REQUEST_POINT_BALANCE_SUCCESS]: (res) => ({ res }),
    [REQUEST_POINT_BALANCE_FAIL]: (res) => ({ res }),

    [REQUEST_POINT_EXPIRE_START]: (req) => ({ ...req }),
    [REQUEST_POINT_EXPIRE_SUCCESS]: (res) => ({ res }),
    [REQUEST_POINT_EXPIRE_FAIL]: (res) => ({ res }),

})

